import { useEffect, useState } from "react";
import logo from "../assets/images/logo.png";

function TopBar({ sidebarTheme, onMenuClick }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        height: isMobile ? 56 : 72,
        padding: isMobile ? "0 12px" : "0 20px",

        display: "flex",
        alignItems: "center",
        gap: 12,

        background: sidebarTheme.card,
        color: sidebarTheme.text,
        borderBottom: `1px solid ${sidebarTheme.border}`,
      }}
    >
      {/* MENU BUTTON */}
      <button
        onClick={onMenuClick}
        style={{
          width: 44,
          height: 44,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          background: "transparent",
          color: sidebarTheme.text,

          fontSize: 26,
          fontWeight: 700,

          borderRadius: 10,
          border: `1px solid ${sidebarTheme.border}`,

          cursor: "pointer",
        }}
      >
        ☰
      </button>
      {/* LOGO */}
      <div
        style={{
          width: isMobile ? 44 : 56,
          height: isMobile ? 44 : 56,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          borderRadius: 20,
        }}
      >
        <img
          src={logo}
          alt="SpeedDigits Logo"
          style={{
            width: "80%",
            height: "80%",
            objectFit: "contain",
          }}
        />
      </div>

      {/* TITLE */}
      <strong
        style={{
          fontSize: isMobile ? 14 : 18,
          fontWeight: 700,
          letterSpacing: "0.3px",

          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        SpeedDigits Trainer
      </strong>
    </div>
  );
}

export default TopBar;
